import { createFileRoute } from '@tanstack/react-router';
import { Content } from '@/components/ui/content';
import { meta } from '@/lib/meta';
import { useSetlist } from '@/services/setlists';
import { SetlistEditor } from '../+components/setlist-editor';

export const Route = createFileRoute('/_app/setlists/$id/')({
  head: () => meta({ label: 'Editar repertório' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data } = useSetlist(id);

  return (
    <Content
      isLoading={!data}
      breadcrumbs={{
        icon: 'list-music',
        title: data?.name ?? 'Editar repertório',
        items: [
          { label: 'Repertórios', route: '/setlists' },
          { label: 'Edição', active: true },
        ],
      }}
    >
      {/* `key`: remonta o editor se trocar de repertório, reiniciando a lista local */}
      {data && <SetlistEditor key={data.id} setlist={data} />}
    </Content>
  );
}
